export const SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_REQUEST =
  'SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_REQUEST';
export const SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS =
  'SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS';
export const SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_FAIL =
  'SHARED_SEND_OTP_FOR_FORGOT_PASSWORD_FAIL';

export const SHARED_FORGOT_UPDATE_PASSWORD_REQUEST =
  'SHARED_FORGOT_UPDATE_PASSWORD_REQUEST';
export const SHARED_FORGOT_UPDATE_PASSWORD_SUCCESS =
  'SHARED_FORGOT_UPDATE_PASSWORD_SUCCESS';
export const SHARED_FORGOT_UPDATE_PASSWORD_FAIL =
  'SHARED_FORGOT_UPDATE_PASSWORD_FAIL';

export const SHARED_LOGIN_REQUEST = 'SHARED_LOGIN_REQUEST';
export const SHARED_LOGIN_SUCCESS = 'SHARED_LOGIN_SUCCESS';
export const SHARED_LOGIN_FAIL = 'SHARED_LOGIN_FAIL';
export const SHARED_LOGOUT = 'SHARED_LOGOUT';

export const SHARED_ADD_ANNOUNCEMENT_REQUEST = 'SHARED_ADD_ANNOUNCEMENT_REQUEST';
export const SHARED_ADD_ANNOUNCEMENT_SUCCESS = 'SHARED_ADD_ANNOUNCEMENT_SUCCESS';
export const SHARED_ADD_ANNOUNCEMENT_FAIL = 'SHARED_ADD_ANNOUNCEMENT_FAIL';

export const SHARED_DELETE_ANNOUNCEMENT_REQUEST = 'SHARED_DELETE_ANNOUNCEMENT_REQUEST';
export const SHARED_DELETE_ANNOUNCEMENT_SUCCESS = 'SHARED_DELETE_ANNOUNCEMENT_SUCCESS';
export const SHARED_DELETE_ANNOUNCEMENT_FAIL = 'SHARED_DELETE_ANNOUNCEMENT_FAIL';

export const SHARED_GET_ANNOUNCEMENT_REQUEST = 'SHARED_GET_ANNOUNCEMENT_REQUEST';
export const SHARED_GET_ANNOUNCEMENT_SUCCESS = 'SHARED_GET_ANNOUNCEMENT_SUCCESS';
export const SHARED_GET_ANNOUNCEMENT_FAIL = 'SHARED_GET_ANNOUNCEMENT_FAIL';